/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import ReactDOM from "react-dom";
import axios from 'axios';
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { Table } from 'reactstrap';
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import {setProducts,updateCategory,setQuote,initQuote,setLogo,setRevise} from '../actions/quote'
import Category from "./Category.js"
import {supplier_arry} from "../config"
import { toast } from 'react-toastify';
import OrderHeader from "./IndexSections/OrderHeader.js";
import TabsClient from "./Orderspart/TabsClient";

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";

import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";




function Index(props) {
  // const [state, setState] = useState([]);
  const [openAddProduct, setOpenAddProduct] = useState(false);
  const [discount, setDiscount] = useState(0);
  const [approvedPrice, setApprovedPrice] = useState(0);
  const main = useRef();
  const [modal, setModal] = useState(false);
  const [orderId, setOrderId] = useState(null);
  const [sendWordflowConfirm, setSendWordflowConfirm] = useState(false)

  useEffect(() => {
    props.initQuote()
    let { id } = props.match.params
    axios.get(`/quotes/edit/${id}`).then(res => {
      console.log('res.data',res.data)
      if(res.data.status == "success")
        var quote = res.data.data
        if(quote){
          var categories = JSON.parse(quote.content);
          for(var key in categories){
            var category = {...categories[key]};
            var items = category['items']
            var groups = category['groups']
            for(var loop = 0; loop < items.length; loop++){
              if(groups){
                var group = groups[loop]
                if("fee_price" in group){
                  group['fee_price'] = (group['fee_price']*1).toFixed(2)
                }
                else{
                  group['fee_price'] = (0).toFixed(2)
                }
                if("price" in group){
                  group['price'] = (group['price']*1).toFixed(2)
                }
                else{
                  group['price'] = (0).toFixed(2)
                }
                if("discount_price" in group){
                  group['discount_price'] = (group['discount_price']*1).toFixed(2)
                }
                else{
                  group['discount_price'] = (0).toFixed(2)
                }
                group.cost_visible = false
                items[loop]['group_options'] = group    
              }   
            }
            category['items'] = items;
            categories[key] = category;
          }
          setApprovedPrice((quote.approved_price*1).toFixed(2));
          setDiscount((quote.discount*1).toFixed(2))
  
          var init_quote = {
            user_id: quote.user_id?quote.user_id:null,   
            categories: categories,
            selectedContactUser: quote.contact_user?quote.contact_user:null,            
            selectedContactAddress: quote.contact_address?quote.contact_address:null,
            selectedContactInfo: quote.contact_info?quote.contact_info:null,
            validDate: quote.valid_to?quote.valid_to:null,
            delivery_required: quote.delivery_required?quote.delivery_required:null,
            pickup_instore: quote.pickup_instore?quote.pickup_instore:null,
            collection_id: quote.collection_id?quote.collection_id:null,
            id: quote.id?quote.id:null,
            revision: quote.revision?quote.revision:null,
            memo_note: quote.memo_note,
            totalPrice: quote.price,
            gst: quote.gst,
            status: quote.status,
            order_status: quote.order_status,
            quoteLabel: quote.label,
            clientLabel: quote.client_label,
            defaultBrand: quote.default_brand,
            created_at: quote.created_at,
            wfm_order_no: quote.wfm_order_no
          };
          props.setQuote(init_quote)
        }
    }) 
    setOrderId(id) 
  },[]);


  const renderCategory=()=>{
    const quote = props.quote;
    const categories = quote.categories;
    var elements = [];
    var position = 0;
    if(categories[0]){
      const category = categories[0]
      elements.push(
        <Category history={props.history} mode="view" category={category.category_info} state={category.items} groups={category.groups} updateCategory={props.updateCategory} />
      )
    }
    else{
      elements.push(
        <Category history={props.history} mode="view" category={null} state={[]} groups={[]} updateCategory={props.updateCategory}/>
      )
    }
    return elements;
  }

  const sendWorkflowmax=async(orderId, wfm_category)=>{    
    setSendWordflowConfirm(false)
    var bodyFormData = new FormData();
    bodyFormData.append('wfm_category',wfm_category?wfm_category:'')
    // if(logoRef.current.files[0])
    //   bodyFormData.append('logo', logoRef.current.files[0]);
    axios.post(`/quotes/sendworkflowmax/${orderId}`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){        
        toast.success("Your order has been saved into workflowmax");
      }
      else{
        toast.error(result.data);
      }
    }).catch(err => {
      toast.error('Something was wrong. Try again');
    })
  }

  const user = localStorage.getItem('user_bigbrand');
  var role = ""
  if(user && user != undefined){
    var userinfo = JSON.parse(user)
    role = userinfo['role']
  }
  let { id } = props.match.params
  return (
    <>
      <DemoNavbar />
      <main ref={main}>
        <Container fluid="lg" className="m-auto">
          <Row className="mt-6">
            <Col  md="12">
              <TabsClient history={props.history}/>
              <div style={{marginTop:10}}>
                <OrderHeader  mode="view"/>
              </div>
              {
                renderCategory()
              }
              {role == 'admin'&& 
              <Row style={{marginTop:'60px'}}>
                <Col lg="6"></Col>
                <Col lg="6">
                  <div className="d-flex" style={{justifyContent:'flex-end'}}>
                    <FormGroup className="text-center">
                      <Label><strong>Approve price</strong></Label>
                      <div className="d-flex align-items-center">
                      $&nbsp;<Input placeholder="Total" disabled value={approvedPrice} onChange={(e)=>setApprovedPrice(e.target.value)} type="number" step="0.01"/>
                      </div>
                    </FormGroup>
                    <FormGroup className="ml-4 text-center">
                      <Label><strong>Discount</strong></Label>
                      <div className="d-flex align-items-center">
                        $&nbsp;<Input placeholder="Discount" disabled value={discount} onChange={(e)=>setDiscount(e.target.value)} type="number" step="0.01"/>
                      </div>
                    </FormGroup>
                    <FormGroup className="ml-4 text-center">
                      <Label className="d-block"><strong>Total</strong></Label>
                      <Label className="mt-2">$&nbsp;<strong>{(parseFloat(approvedPrice) - parseFloat(discount)).toFixed(2)}</strong></Label>
                    </FormGroup>
                  </div>
                </Col>
                {/* <Col lg="6">
                  <Summary/>
                </Col> */}
              </Row>
              }  
            </Col>
          </Row>
        </Container>
      </main>
      <CardsFooter/>
      <Modal isOpen={sendWordflowConfirm} toggle={()=>setSendWordflowConfirm(false)} >
        <ModalHeader toggle={()=>setSendWordflowConfirm(false)}>Confirm</ModalHeader>
        <ModalBody>
          Are you sure to send to workflowmax?
        </ModalBody>
        <ModalFooter>
          <Button color="primary" size="sm" onClick={()=>sendWorkflowmax(false)}>Yes</Button>{' '}
          <Button color="secondary" size="sm" onClick={()=>setSendWordflowConfirm(false)}>No</Button>
        </ModalFooter>
      </Modal>
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setProducts: products=>dispatch(setProducts(products)),
    updateCategory: cat=>dispatch(updateCategory(cat)),
    setQuote: quote=>dispatch(setQuote(quote)),
    initQuote:()=>dispatch(initQuote()),
    setLogo:logo=>dispatch(setLogo(logo)),
    setRevise:data=>dispatch(setRevise(data)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
